import { render, staticRenderFns } from "./RegisterModuleQuiz.vue?vue&type=template&id=e7950bb4&scoped=true&"
import script from "./RegisterModuleQuiz.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleQuiz.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleQuiz.vue?vue&type=style&index=0&id=e7950bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7950bb4",
  null
  
)

export default component.exports